module.exports = __webpack_public_path__ + "img/z_tech.20956c7e.svg";